export const LOAD_MAP = 'LOAD_MAP';

export const FETCH_MAP = 'FETCH_MAP';

export const SET_AVAILABLE_MAPS = "SET_AVAILABLE_MAPS";

export const SET_SELECTED_MAP = "SET_SELECTED_MAP";

export const SET_RENDERER = "SET_RENDERER";

export const RENDERER_THREE = "ThreeJS Render";

export const RENDERER_SVG = "SVG Render";

export const SET_DESTINATION = "SET_DESTINATION";

export const SET_ORIGIN = "SET_ORIGIN";

export const SET_SELECTED_POI = "SET_SELECTED_POI";


// WEBPACK FOOTER //
// ./src/constants/map.js